<ng-template #content let-c="close" let-d="dismiss">
  <div class="lna-modal-header">
    <div class="inline">
      <h4 class="modal-title">
        {{ 'components.cancelSubmission.title' | translate }}
      </h4>
      @if (shouldRenderTooltip) {
        <app-tooltip [marginBottom]="false" text="cancelSubmission" />
      }
    </div>
    <button class="btn-close" (click)="hide()" type="button" aria-label="Close"></button>
  </div>
  <div class="lna-modal-body">
    <form [formGroup]="form">
      <h4 class="modal-question" id="modal-basic-question">
        @if (application?.visitTimeTo) {
          {{
            'components.cancelSubmission.cancelSubmissionQuestionWithTo'
              | translate
                : {
                    date: formatDate(application?.visitDate!),
                    timeFrom: formatTime(application?.visitTimeFrom),
                    timeTo: formatTime(application?.visitTimeTo)
                  }
          }}
        } @else {
          {{
            'components.cancelSubmission.cancelSubmissionQuestionWithoutTo'
              | translate: { date: formatDate(application?.visitDate!), timeFrom: formatTime(application?.visitTimeFrom) }
          }}
        }
      </h4>
      <div class="lna-row-32 full-width">
        <div class="label-wrapper">
          <label class="form-label lna" for="text">
            {{ 'components.cancelSubmission.text' | translate }}
            <span class="required-field">*</span>
          </label>
        </div>
        <div class="textarea-wrapper">
          <textarea
            class="form-control lna m-0"
            id="text"
            [ngClass]="{ invalid: shouldRenderError('text') }"
            type="text"
            formControlName="text"
            name="text"
            required
            maxlength="{{ maxDescriptionLength }}"></textarea>
          <p
            class="length"
            [ngClass]="{
              invalid: text?.value?.length > maxDescriptionLength
            }">
            {{ text?.value?.length }}/{{ maxDescriptionLength }}
          </p>
        </div>
        @if (getErrorMessage('text'); as errorMessage) {
          <div class="error-wrapper">
            <small class="error-message">
              {{ errorMessage | translate }}
            </small>
          </div>
        }
      </div>
    </form>
  </div>
  <div class="lna-modal-footer">
    <button class="primary" (click)="handleSave()" type="button">
      {{ 'components.cancelSubmission.submit' | translate }}
    </button>
    <button class="secondary" (click)="hide()" type="button">
      {{ 'components.cancelSubmission.cancel' | translate }}
    </button>
  </div>
</ng-template>
